import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import AuthentifiedPage from "./AuthentifiedPage";
import "../styles/RapportPage.css";
import { Indicateur } from "../types/Indicateur";
import { indicateurService } from "../services/IndicateurService";

const RapportPage: React.FC = () => {
  const { api } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const { domain, sousDomain, sousSousDomain } = location.state || {};

  const tableName =
    sousSousDomain?.label ||
    sousDomain?.label ||
    domain?.label ||
    "Indicateur";

  const [indicateurs, setIndicateurs] = useState<Indicateur[]>([]);
  const [selected, setSelected] = useState<number[]>([]);
  const [loading, setLoading] = useState(false);

  const loadIndicateurs = async () => {
    if (!api) {
      console.error("API non disponible");
      return;
    }

    setLoading(true);
    try {
      const idFenetre = sousDomain?.id ?? domain?.id;
      const idSousFenetre = sousSousDomain?.id ?? null;

      if (!idFenetre) {
        setIndicateurs([]);
        return;
      }

      const data = await indicateurService.getIndicateursByFenetre(
        api,
        idFenetre,
        idSousFenetre ?? undefined
      );

      const mappedData: Indicateur[] = data.map((ind: any, index: number) => ({
      id: ind.idIndicateur ?? index,
      nom: ind.nom,
      formule: ind.formule,
      tableName: ind.tableName || ind.table_name || "N/A",
      valeur: ind.valeur || 0,
      isAccepted: ind.isAccepted ?? ind.is_accepted ?? false,
      idFenetre: ind.idFenetre ?? ind.id_fenetre ?? null,
      idSousFenetre: ind.idSousFenetre ?? ind.id_sous_fenetre ?? null,
      unite: ind.unite ?? null,
      createdAt: ind.createdAt || ind.created_at,
    }));

    const acceptedOnly = mappedData.filter(ind => ind.isAccepted === true);
    setIndicateurs(acceptedOnly);

    } catch (err: any) {
      console.error("Erreur lors du chargement des indicateurs :", err);
      alert("Impossible de charger les indicateurs");
      setIndicateurs([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadIndicateurs();
  }, [api, domain, sousDomain, sousSousDomain]);

  const toggleSelect = (id: number) => {
    setSelected((prev) =>
      prev.includes(id) ? prev.filter((s) => s !== id) : [...prev, id]
    );
  };

  const createRapportWithIndicateurs= async ()=>{
    if (selected.length === 0) {
      alert("Veuillez sélectionner au moins un indicateur.");
      return;
    }

    const indicateursChoisis = indicateurs.filter((ind) =>
      selected.includes(ind.id)
    );

    navigate("/rapport-builder", {
        state: {
          name: tableName,
          tableName,
          indicateurs: indicateursChoisis,
        },
      });
  }

  return (
    <AuthentifiedPage>
      <div style={{ maxWidth: 900, margin: "20px auto", fontFamily: "Arial" }}>
        <h3>
          Rapport – <span style={{ color: "green" }}>{tableName}</span>
        </h3>

        {loading ? (
          <p style={{ marginTop: 20 }}>Chargement des indicateurs...</p>
        ) : indicateurs.length === 0 ? (
          <p style={{ marginTop: 20 }}>Aucun indicateur trouvé pour ce menu.</p>
        ) : (
          <>
            <p style={{ marginTop: 15 }}>
              Sélectionnez les indicateurs à inclure dans le rapport (modèles seulement) :
            </p>

            {indicateurs.map((ind, index) => {              
              return (
                <div
                  key={ind.id}
                  style={{
                    padding: 12,
                    border: "1px solid #ddd",
                    borderRadius: 6,
                    background: "#fafafa",
                    marginBottom: 15,
                    display: "flex",
                    alignItems: "center",
                    gap: 12,
                  }}
                >
                  <input
                    type="checkbox"
                    checked={selected.includes(ind.id)}
                    onChange={() => {
                      toggleSelect(ind.id);
                    }}
                    style={{ width: 18, height: 18 }}
                  />
                  <div style={{ flexGrow: 1 }}>
                    <h5 style={{ marginBottom: 5 }}>{ind.nom}</h5>
                    <div style={{ fontSize: 13 }}>
                      <strong>Formule :</strong> {ind.formule}
                    </div>
                  </div>
                </div>
              );
            })}


            <button className="btn-import" onClick={createRapportWithIndicateurs}>
              Créer le rapport
            </button>
          </>
        )}
      </div>
    </AuthentifiedPage>
  );
};

export default RapportPage;